module.exports = __webpack_public_path__ + "static/media/list-ol.be625ec3.svg";